import { Box, Button, keyframes } from "@chakra-ui/react";
import { KYDAdminEvent } from "@common/interfaces/KYDEvent";

const LaunchEventButton = ({
  kydEvent,
  onLaunchEvent,
  loading,
}: {
  loading: Record<string, boolean>;
  onLaunchEvent: () => void;
  kydEvent?: KYDAdminEvent;
}) => {
  const pulse = keyframes({
    "0%": {
      backgroundPosition: "0% 50%",
    },
    "50%": {
      backgroundPosition: "100% 50%",
    },
    "100%": {
      backgroundPosition: "0% 50%",
    },
  });

  if (!kydEvent) {
    return null;
  }

  return kydEvent.ticket_types.filter((tt) => tt.status === "DRAFT").length >
    0 &&
    kydEvent.image &&
    kydEvent.status !== "PENDING_APPROVAL" &&
    kydEvent.description ? (
    <Box
      bg="white"
      borderWidth={"1px"}
      borderColor={"gray.100"}
      roundedTop={"lg"}
      p={4}
      w="100%"
      shadow={"lg"}
      bottom={0}
      position={"sticky"}
    >
      <Button
        onClick={() => onLaunchEvent()}
        isDisabled={loading["blocking"]}
        isLoading={loading["blocking"]}
        background="linear-gradient(-45deg, #FFA63D, #FF3D77, #338AFF, #3CF0C5)"
        backgroundSize="600%"
        animation={`${pulse} 4s linear infinite`}
        color="white"
        w="100%"
        h="50px"
        _hover={{ backgroundColor: "none" }}
      >
        {`Launch ${kydEvent.status === "OPEN" ? "Changes" : "Event"} 🚀`}
      </Button>
    </Box>
  ) : null;
};

export default LaunchEventButton;